<template>
  <div class="container">
    <div class="activityItem" @click.stop="courseDetailEvent()" ref="activityItem">
      <img class="activityimg" :src="dic.photo" />
      <div class="wrap">
        <div class="title">
          <div class="name">{{dic.name}}</div>
        </div>
        <div class="des">{{dic.content}}</div>
        <div class="bottom">
          <div class="time" v-if="!dic.finished">{{time}}</div>
          <div class="end" v-else>已结束</div>
          <div class="btns" v-if="!dic.finished">
            <span class="btn" @click.stop="goSignup()" v-if="dic.has_signup">我要报名</span>
            <span class="btn" @click.stop="courseDetailEvent()" v-if="dic.has_work">上传作品</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from "@/utils";
import { IMG_EYE } from "@/assets";

import { types as ActivityTypes } from "@/store/modules/activity.js";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "ActivityItem",
  components: {},
  props: {
    dic: {
      currentActivity: Object
    }
  },
  data() {
    return {
      images: {},
      length: 0
    };
  },
  computed: {
    time() {
      let start = this.dic.start_time
        ? this.dic.start_time.split("T")[0].replace(/-/g, "/")
        : "null";
      let end = this.dic.end_time
        ? this.dic.end_time.split("T")[0].replace(/-/g, "/")
        : "null";
      return "活动时间：" + start + "  --  " + end;
    },
    enableClick() {
      let time = this.dic.start_time ? new Date(this.dic.start_time) : null;
      let nowTime = new Date();
      if (nowTime > time) {
        return true;
      } else {
        return false;
      }
    }
  },

  methods: {
    ...mapMutations({
      setDetail: ActivityTypes.SET_CURRENT_ACTIVITY
    }),
    ...mapActions({}),

    ...Utils,
    goSignup(){
      if (!this.enableClick) {
        this.$message.error("活动尚未开始");
        return;
      }
      
      let pk = this.dic.number;
      this.$router.push(`/ActivityApply/${pk}`);
    },
    courseDetailEvent() {
      if(this.dic.has_work){
        if (!this.enableClick) {
          this.$message.error("活动尚未开始");
          return;
        }
        this.setDetail(this.dic);
        let pk = this.dic.number;
        this.$router.push(`/ActivityDetail/${pk}`);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.activityItem {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  cursor: pointer;
  .activityimg {
    display: inline-block;
    width: 93%;
    // height:289px;
    border-radius: 15px;
    margin: 0 auto;
    margin-top: 20px;
    background: #f4f3f3;
    background-repeat: no-repeat;
    background-size: cover;
    // border-top: 1px solid #dedede;
  }
  .wrap {
    display: inline-block;
    width: 93%;
    margin: 20px auto;
    background-size: cover;
    .title {
      display: block;
      width: 100%;
      color: rgba(51, 51, 51, 1);
      margin-top: -10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        font-size: 0.9rem;
        line-height: 1.1rem;
      }
    }
    .des {
      display: block;
      width: 100%;
      color: #666666;
      font-size: 0.7rem;
      margin-top: 0.4rem;
      line-height: 1.3rem;
    }
    .bottom{
      margin-top: 5px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .time {
        height: 1.1rem;
        font-size: 14px;
        color: #6b45e1;
        // line-height: 1.1rem;
        // background: #6b45e1;
        // padding: 0 0.5rem;
        border-radius: 0.55rem;
        flex-shrink: 0;
      }
      .end {
        height: 1.1rem;
        font-size: 0.7rem;
        color: #ffffff;
        line-height: 1.1rem;
        background: #ff7b00;
        padding: 0 0.5rem;
        border-radius: 0.55rem;
        flex-shrink: 0;
      }
      .btns{
        .btn{
          height: 35px;
          font-size: 14px;
          color: #ffffff;
          background: #6b45e1;
          padding: 5px 10px;
          border-radius: 25px;
          margin-left: 15px;
        }
      }
    }
  }

  .begin {
    background-color: #ff7b00;
    font-size: 13px;
    color: #ffffff;
    width: 70px;
    text-align: center;
    height: 25px;
    line-height: 25px;
    border-radius: 15px;
    cursor: pointer;
  }
}
</style>
